import {Component, EventEmitter, Input, Output, Signal, signal, ChangeDetectionStrategy} from '@angular/core';

@Component({
	selector: 'peps-bell-popup',
	imports: [
	],
	templateUrl: './bell-popup.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: './bell-popup.component.css'
})
export class BellPopupComponent {
	@Input() isOpen: Signal<boolean> = signal(false);
	@Output() closePopup = new EventEmitter();
	@Output() enableNotification = new EventEmitter();
	@Output() disableNotification = new EventEmitter();
	@Input() isSubscribed: boolean = false;

	enableNotifications() {
		this.enableNotification.emit();
		this.close();
	}

	disableNotifications() {
		this.disableNotification.emit();
		this.close();
	}

	close() {
		this.closePopup.emit();
	}
}
